import React from "react";
import "./aboutPage.css";

const AboutPage = () => {
	return (
		<div className="about-page">
			<h1>About me</h1>
			<div className="about-info">
				<p>Hey there! I'm Claude Nijem.</p>
				<p>A Full-Stack developer and Indie Game developer.</p>
				<p>
					Born the year 2000 in Israel. I was always into computers,
					so I decided to follow through my dreams and learn
					programming and development.
				</p>
				<p>
					I learned to program in many languages and how to use a
					couple game engines but I ended up sticking with Godot.
				</p>
			</div>
			<div className="about-bottom">
				<div className="about-image">
					<img
						src={require("../../assets/me.png")}
						alt="Me wearing a suit"
					/>
				</div>
				<div className="about-extra">
					<div className="about-skills">
						<div>
							<h2 className="skill-title">
								Programming Languages
							</h2>
							<p> - JavaScript</p>
							<p> - Python</p>
							<p> - C#</p>
							<p> - TypeScript</p>
						</div>
					</div>
					<div className="about-skills">
						<div>
							<h2 className="skill-title">Front End</h2>
							<p> - HTML</p>
							<p> - CSS</p>
							<p> - ReactJS</p>
							<p> - NextJS</p>
						</div>
					</div>
					<div className="about-skills">
						<div>
							<h2 className="skill-title">Back End</h2>
							<p> - NodeJS</p>
							<p> - ExpressJS</p>
							<p> - Flask Python</p>
							<p> - Microsoft Azure</p>
						</div>
					</div>
					<div className="about-skills">
						<div>
							<h2 className="skill-title">Game Development</h2>
							<p> - Godot</p>
							<p> - GDScript</p>
							<p> - Unity</p>
						</div>
					</div>
					<div className="about-skills">
						<div>
							<h2 className="skill-title">Other</h2>
							<p> - Photo Editing</p>
							<p> - Video Editing</p>
						</div>
					</div>
					<div className="about-skills">
						<div>
							<h2 className="skill-title">Languages</h2>
							<p> - Arabic : Native</p>
							<p> - English : Proficient</p>
							<p> - Hebrew : Intermediate</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AboutPage;
